import { LOTTO_CONSTANTS } from '../constants';

export const buildCartItemFromTicket = (
  ticket,
  editedNumbers,
  editedStake,
  potentialPayout,
  editedRepeatForDraws,
  acceptOddsChanges,
  singleBetsCount
) => {
  const hasBalls = ticket.balls != null;

  return {
    id: `${ticket.draw_id}-${ticket.market_type}-${Date.now()}`,
    ticket_id: ticket.ticket_id ?? '',
    draw_date: ticket.draw_date,
    draw_id: ticket.draw_id,
    draw_number: ticket.draw_number,
    lottery_name: ticket.lottery_name,
    market_category: ticket.market_category,
    market_title: ticket.market_title,
    market_type: ticket.market_type,
    outcome: {
      id: ticket.outcome.id,
      odds: ticket.outcome.odds,
      outcome_type: ticket.outcome.outcome_type,
      outcome_title: ticket.outcome.outcome_title,
    },
    balls: hasBalls ? editedNumbers : null,
    stake: Math.round(editedStake * LOTTO_CONSTANTS.CENTS_MULTIPLIER),
    to_pay: Math.round(
      editedStake * singleBetsCount * LOTTO_CONSTANTS.CENTS_MULTIPLIER
    ),
    main_grid_total: ticket.main_grid_total,
    secondary_grid_total: ticket.secondary_grid_total,
    secondary_unique: ticket.secondary_unique,
    potential_payout: potentialPayout,
    repeat_for_draws: editedRepeatForDraws,
    change_odds_agreement: acceptOddsChanges,
    single_bets_count: singleBetsCount,
  };
};
